module.exports = __webpack_public_path__ + "static/media/gauntlet-common.65193182.png";